<template>
  <button
    :type="type"
    :disabled="disabled"
    class="btn"
    :class="[variantClass, sizeClass, roundedClass]"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'danger-outline'
    | 'amber-outline'
    | 'purple'
    | 'indigo'
    | 'emerald'
    | 'outline'
    | 'ghost'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  rounded?: 'sm' | 'md' | 'lg' | 'full'
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'md',
  rounded: 'lg',
  type: 'button',
  disabled: false,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const variantClass = computed(() => {
  switch (props.variant) {
    case 'primary':
    case 'success':
    case 'emerald':
      return 'btn-primary'
    case 'secondary':
      return 'btn-secondary'
    case 'danger':
      return 'btn-danger'
    case 'danger-outline':
      return 'btn-danger-outline'
    case 'amber-outline':
      return 'btn-amber-outline'
    case 'purple':
      return 'btn-purple'
    case 'indigo':
      return 'btn-indigo'
    case 'outline':
      return 'btn-outline'
    case 'ghost':
      return 'btn-ghost'
    default:
      return 'btn-primary'
  }
})

const sizeClass = computed(() => `btn-${props.size}`)

const roundedClass = computed(() => `btn-rounded-${props.rounded}`)

const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit('click', event)
  }
}
</script>
